import moment from 'moment'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { useAuthContext } from './contexts/AuthContext'
import { useGeneralContext } from './contexts/GeneralContext'
import MarkTableResults from './partials/MarkTableResults'
import ZoomingAnimation from './partials/ZoomingAnimation'
import { navDirections } from './utils/navDirections'

function Results() {
    const { userDetails } = useAuthContext()

    const {
        setRankListSelected,
        setGetRankListStatus,
        loading,
        setLoading,
        results,
        mode,
        setMode,
        offlineRanklist,
        setGetOfflineRankListStatus
    } = useGeneralContext()

    const history = useHistory()

    useEffect(() => {
        setLoading(true)
        setGetRankListStatus(true)
        setGetOfflineRankListStatus(true)
    }, [])

    return (
        <ResultContainer>
            <Heading>Results</Heading>
            <div
                style={{
                    color: 'white',
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                    width: '100%',
                    fontWeight: '500',
                    position: 'fixed',
                    zIndex: '99',
                    top: '60px',
                    backgroundColor: '#2e2e53',
                    boxShadow:
                        '-1px 3px 14px rgba(0, 0, 0, 0.12),2px 8px 10px rgba(0, 0, 0, 0.14), 2px 5px 5px rgba(0, 0, 0, 0.2)'
                }}
            >
                <p
                    onClick={() => setMode('online')}
                    style={{
                        width: '50%',
                        textAlign: 'center',
                        padding: '16px 0',
                        backgroundColor:
                            mode === 'online' ? '#24243fa6' : 'transparent'
                    }}
                >
                    Online
                </p>
                <p
                    onClick={() => setMode('offline')}
                    style={{
                        width: '50%',
                        textAlign: 'center',
                        padding: '16px 0',
                        borderRight: '1px solid #ffffff5c',
                        backgroundColor:
                            mode === 'offline' ? '#24243fa6' : 'transparent'
                    }}
                >
                    Offline
                </p>
            </div>

            {!!offlineRanklist.length &&
                mode === 'offline' &&
                offlineRanklist.map((el, key) => (
                    <ResultCard key={key}>
                        <ExamTitleOffline>{el?.exam}</ExamTitleOffline>

                        <MarkTableResults
                            totalMark={el.totalMark}
                            percentage={
                                el?.rankList.find(
                                    (item) => item.id === userDetails?.uid
                                )?.percentage || '-- '
                            }
                            rank={
                                el?.rankList.find(
                                    (item) => item.id === userDetails?.uid
                                )?.rank || '---'
                            }
                            yourMark={
                                el?.rankList.find(
                                    (item) => item.id === userDetails?.uid
                                )?.mark || 'ABSENT'
                            }
                        />
                        <DateInCard>
                            {moment(new Date(el.dateOfExam.toDate())).format(
                                'DD/MM/YYYY'
                            )}
                        </DateInCard>

                        <GotoButton>
                            <button
                                onClick={() => {
                                    setRankListSelected(el)
                                    history.push(navDirections.EXAM_RANK_LIST)
                                }}
                            >
                                View Rank List
                            </button>
                        </GotoButton>
                    </ResultCard>
                ))}

            {!!results.length &&
                mode === 'online' &&
                results.map((el, key) => (
                    <ResultCard key={key}>
                        <SubjectName>{el.subject}</SubjectName>
                        <ExamTitle>{el.title}</ExamTitle>

                        <MarkTableResults
                            totalMark={el.totalMark}
                            percentage={el.percentage}
                            rank={el.Rank}
                            yourMark={el.yourMark}
                        />
                        <DateInCard>{el.date}</DateInCard>

                        <GotoButton>
                            <button
                                onClick={() => {
                                    setRankListSelected(el)
                                    history.push(navDirections.EXAM_RANK_LIST)
                                }}
                            >
                                View Rank List
                            </button>
                        </GotoButton>
                    </ResultCard>
                ))}
            {!!!results.length && mode === 'online' && loading && (
                <ZoomingAnimation />
            )}

            {!!!results.length && mode === 'online' && !loading && (
                <NotAvailable>No Results Available</NotAvailable>
            )}
        </ResultContainer>
    )
}

const ResultContainer = styled.div`
    padding-top: 6rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const ResultCard = styled.div`
    margin-top: 40px;
    padding: 30px 20px;
    max-width: 500px;
    background: #2e2e53;
    box-shadow: -5px 3px 14px rgba(0, 0, 0, 0.12),
        2px 8px 10px rgba(0, 0, 0, 0.14), 2px 5px 5px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    color: #fff;
`
const SubjectName = styled.p`
    font-weight: 600;
    color: #fff;
    text-align: center;
    font-size: 18px;
`
const ExamTitle = styled.p`
    font-weight: 400;
    color: #fff;
    text-align: center;
    margin: 15px 0;
`
const ExamTitleOffline = styled.p`
    font-weight: 500;
    color: #fff;
    text-align: center;
    margin: 15px 0;
`
const DateInCard = styled.p`
    font-weight: 600;
    color: #9f9fb0;
    text-align: right;
    margin-top: 20px;
`

const GotoButton = styled.div`
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    > button {
        padding: 15px 20px;
        font-family: inherit;
        outline: none;
        border: none;
        border-radius: 6px;
        width: 100%;
        color: #fff;
        background: #363862;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
    }
`

const NotAvailable = styled.p`
    text-align: center;
    color: #fff;
    margin: 30px 0;
`

export default Results
